import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputNumberWrapper, SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import {clearFields} from '../../../../../../util/functions'
import {useCamp, useClient, useCompany, useSite} from '../../../../../central/hooks'
import {getMasterModuleService} from '../../../../../hoteleria/features/modules/services'
import {useTableMaster} from '../../../../hooks'
import {SelectModel} from '../../../../model'
import {getLaundryConfigDaysById} from '../../../../services'
import {TITLE_FORM_CONFIG_DAYS} from '../../../../util/Constants'
import HeaderTitle from '../../../componentes/Form/Header'
const ConfigDay: FC = () => {
  const {setError, setValue, reset, watch} = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const {getStatusUserList, typeLaundryOrderLN, getTypeLaundryOrderListLongName} = useTableMaster()
  const [guestTypes, setGuestTypes] = useState<SelectModel[]>([])

  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
    }
    setCamps(response)
  }
  const getGuestTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoHuesped',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setGuestTypes(mappedModuleTypes)
    } catch (error) {
      setGuestTypes([])
    }
  }

  const getConfigDayByIdValues = async () => {
    const response = await getLaundryConfigDaysById(currentTabItem.idToEdit)
    const data = response.data.data
    setValue('companiaId', data.companiaId)
    await getClientList(data.companiaId!)
    setValue('clienteId', data.clienteId)
    await getSiteList(data.clienteId!)
    setValue('siteId', data.siteId)
    await getCampList(data.siteId!)
    setValue('campamentoId', data.campamentoId)
    setValue('tipoServicio', data.tipoServicioId)
    setValue('tipoHuespedId', data.tipoHuespedId)
    setValue('valor', data.valor)
  }

  useEffect(() => {
    getCompanyList()
    getStatusUserList()
    getGuestTypes()
    getTypeLaundryOrderListLongName()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getConfigDayByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleGetClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
    clearFields(setValue, setError, {
      clienteId: '',
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
    clearFields(setValue, setError, {
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    setValue('siteId', value)
    setError('siteId', {})
    clearFields(setValue, setError, {
      campamentoId: '',
    })
  }

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_form card p-4'>
      <HeaderTitle isEdit={isDisabled} title={TITLE_FORM_CONFIG_DAYS} handleBack={handleBack} />
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={company}
            disabled={isDisabled}
            onChangeValue={handleGetClient}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clients}
            disabled={isDisabled}
            onChangeValue={handleGetSite}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={sites}
            disabled={isDisabled}
            onChangeValue={handleGetCamp}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Campamento'
            name='campamentoId'
            data={camps}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de Servicio'
            name='tipoServicio'
            data={typeLaundryOrderLN}
            required
          />
        </div>
        {watch('tipoServicio') === 'ROPA HUÉSPED' && (
          <div className='col-sm-12 col-lg-3'>
            <SelectWrapper
              labelText='Tipo de Huésped'
              name='tipoHuespedId'
              data={guestTypes}
              required
            />
          </div>
        )}
        <div className='col-sm-12 col-lg-3'>
          <InputNumberWrapper
            labelText='Cantidad de Días Adicionales'
            name='valor'
            textPlaceholder='Escribe el número'
            required
          />
        </div>
      </div>
    </div>
  )
}

export default ConfigDay
